import { NgModule } from '@angular/core';
import { LibConnectAccountsIconComponent } from './lib-connect-accounts-icon.component';

@NgModule({
  declarations: [LibConnectAccountsIconComponent],
  imports: [],
  exports: [LibConnectAccountsIconComponent],
})
export class LibConnectAccountsIconModule {}
